export default __webpack_public_path__ + "static/media/mTop_2_c3.f75cb004.jpeg";